<template>
  <div>
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-row>
          <b-col class="col-2">
            <strong>Product SKU</strong>
          </b-col>
          <b-col>{{ bo_detail.product_sku }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Product Description</strong>
          </b-col>
          <b-col>{{ bo_detail.product_description }}</b-col>
        </b-row>

        <b-row v-if="partial_committed && partial_committed > 0">
          <b-col class="col-2">
            <strong>Partial Committed</strong>
          </b-col>
          <b-col>{{ partial_committed }}</b-col>
        </b-row>
      </b-card>

      <h4 class="mt-3">
        Orders
      </h4>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        :items="bo_detail.orders"
        :fields="order_fields"
      >
      <template v-slot:cell(order_number)="data">
          <router-link
            :to="{
              name: 'order_master_detail',
              params: { order_master_id: data.item.id }
            }"
          >
            {{ data.item.order_number }}
          </router-link>
        </template>
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox
            size="sm"
            plain
            id="chkbox_all"
            value="all"
            v-model="check_all_rows"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox
            size="sm"
            class="chkbox_row"
            plain
            :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(action)="data">
          <b-button
            v-if="false"
            class="btn-action"
            size="sm"
            variant="success"
            @click.stop="doReceiveOrder(data.item)"
            >Generate BO</b-button
          >
        </template>
      </b-table>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const order_fields = [
  {
    key: "chk_box",
    label: ""
  }
  ,
  {
    key: "created_at",
    label: "Upload Date"
  }
  ,
  {
    key: "order_date",
    label: "Order Date"
  },
  {
    key: "order_number",
    label: "Order Number"
  },
  {
    key: "stock_status",
    label: "Stock Status"
  },
  {
    key: "quantity",
    label: "Quantity"
  },
  {
    key: "committed_qty",
    label: "Partial Committed"
  },
];

import global_function from "../mixins/global_function";

export default {
  name: "DeliveryNoteDetail",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  mixins: [global_function],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      bo_detail: {},
      updating_item: false,
      breadcrumb_items: [
        {
          text: "Order Inventory",
          to: { name: "order_inventory" }
        },
        {
          text: "Detail",
          active: true
        }
      ],
      loader: false,
      bo_detail_orders: [],
      order_fields: order_fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      check_all_rows: false,
      partial_committed: 0,
    };
  },
  async created() {
    await this.getBODetail();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function(new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.bo_detail.orders) {
          this.bo_detail.orders[i].is_checked = true;
        }
      } else {
        for (let i in this.bo_detail.orders) {
          this.bo_detail.orders[i].is_checked = false;
        }
      }
      console.log(this.bo_detail.orders);
    }
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getBODetail() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_inventory_detail_get.php",
        data: {
          product_id: this.$route.query.product_id,
          stock_status: this.$route.query.stock_status,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      if(response.data.partial_committed){
        this.partial_committed = response.data.partial_committed;
      }
      this.bo_detail = response.data.bo_detail;
      for(let i in this.bo_detail.orders){
        if(this.partial_committed && this.partial_committed > 0){
          if(i == 0){
            this.bo_detail.orders[i]['committed_qty'] = this.partial_committed;
          }else{
            this.bo_detail.orders[i]['committed_qty'] = '-';
          }
        }else{
          this.bo_detail.orders[i]['committed_qty'] = '-';
        }
      }

      this.loader.hide();
    },

    async onBulkAction(bulk_action) {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let bo_products = [];

      let bo_product_tmp = JSON.parse(JSON.stringify(this.bo_detail));
      bo_product_tmp.orders = [];
      for (let i in this.bo_detail.orders) {
        if (this.bo_detail.orders[i].is_checked) {
          bo_product_tmp.orders.push(this.bo_detail.orders[i].order_number);
        }
      }

      bo_products.push(bo_product_tmp);

      // call action
      let action_urls = {
        create_bo: "back_order_generate.php"
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: action_urls[bulk_action],
        data: {
          bo_products: bo_products,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Bulk Update Success",
        variant: "success"
      });
      this.getBODetail();
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dev_test {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderInventoryDetail.vue